import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import { ContactsContextProvider as ContactsProvider } from 'contexts/ContactsContext';
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';

const DemandeCarsTable = Loadable(lazy(() => import('pages/cars/demandeCarsTable')));
const RequestCarsTable = Loadable(lazy(() => import('pages/cars/requestCarsTable')));
const InventoryCarsTable = Loadable(lazy(() => import('pages/cars/inventoryCarsTable')));
const PreparationCarsTable = Loadable(lazy(() => import('pages/cars/preparationCarsTable')));
const LitigeCarsTable = Loadable(lazy(() => import('pages/cars/litigeCarsTable')));
const CarSourcingContactsTable = Loadable(lazy(() => import('pages/contacts/carSourcingContactsTable')));
const CarProfile = Loadable(lazy(() => import('pages/cars/carProfile')));
const TabCar = Loadable(lazy(() => import('sections/apps/profiles/car/TabCar')));
const TabCarPhotos = Loadable(lazy(() => import('sections/apps/profiles/car/TabCarPhotos')));
const TabCompanyAnalytics = Loadable(lazy(() => import('sections/apps/profiles/company/TabCompanyAnalytics')));
const TabCompanyContacts = Loadable(lazy(() => import('sections/apps/profiles/company/TabCompanyContacts')));

// ==============================|| APPS ROUTING ||============================== //

const VendorRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: '/',
          element: (
            <ContactsProvider>
              <Outlet />
            </ContactsProvider>
          ),
          children: [
            {
              path: '/demandes',
              element: <DemandeCarsTable />
            },
            {
              path: '/demandes/:id',
              element: <CarProfile />,
              children: [
                {
                  path: '',
                  element: <Navigate to="details" />
                },
                {
                  path: 'details',
                  element: <TabCar />
                },
                {
                  path: 'contacts',
                  element: <TabCompanyContacts />
                },
                {
                  path: 'analytics',
                  element: <TabCompanyAnalytics />
                }
              ]
            },
            {
              path: '/commandes',
              element: <RequestCarsTable />
            },
            {
              path: '/commandes/:id',
              element: <CarProfile />,
              children: [
                {
                  path: '',
                  element: <Navigate to="details" />
                },
                {
                  path: 'details',
                  element: <TabCar />
                },
                {
                  path: 'photos',
                  element: <TabCarPhotos />
                },
                {
                  path: 'analytics',
                  element: <TabCompanyAnalytics />
                }
              ]
            },
            {
              path: '/inventaire',
              element: <InventoryCarsTable />
            },
            {
              path: '/inventaire/:id',
              element: <CarProfile />,
              children: [
                {
                  path: '',
                  element: <Navigate to="details" />
                },
                {
                  path: 'details',
                  element: <TabCar />
                },
                {
                  path: 'contacts',
                  element: <TabCompanyContacts />
                },
                {
                  path: 'analytics',
                  element: <TabCompanyAnalytics />
                }
              ]
            },
            {
              path: '/planning',
              element: <CarSourcingContactsTable />
            },
            {
              path: '/preparation',
              element: <PreparationCarsTable />
            },
            {
              path: '/preparation/:id',
              element: <CarProfile />,
              children: [
                {
                  path: '',
                  element: <Navigate to="details" />
                },
                {
                  path: 'details',
                  element: <TabCar />
                },
                {
                  path: 'photos',
                  element: <TabCarPhotos />
                },
                {
                  path: 'analytics',
                  element: <TabCompanyAnalytics />
                }
              ]
            },
            {
              path: '/litige',
              element: <LitigeCarsTable />
            }
          ]
        }
      ]
    }
  ]
};

export default VendorRoutes;
